import React from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BRAND } from '../../theme/brandTokens';

const ServicePackageCheckboxGroup = ({
  id,
  title,
  helpText,
  emptyText,
  options,
  selectedIds,
  onToggle,
  error,
  disabled,
}) => {
  const { t } = useTranslation();
  const selected = new Set((selectedIds || []).map(String));

  return (
    <Box
      id={id}
      sx={{
        border: '1px solid',
        borderColor: error ? 'error.main' : 'divider',
        borderRadius: 2,
        p: { xs: 2, sm: 2.5 },
      }}
    >
      <Typography variant="subtitle2" sx={{ mb: helpText ? 0.5 : 1, fontWeight: 600 }}>
        {title}
      </Typography>
      {helpText ? (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
          {helpText}
        </Typography>
      ) : null}
      {options.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          {emptyText}
        </Typography>
      ) : (
        <FormGroup>
          {options.map((option) => (
            <FormControlLabel
              key={option.id}
              control={(
                <Checkbox
                  checked={selected.has(String(option.id))}
                  onChange={() => onToggle(option.id)}
                  disabled={disabled || option.disabled}
                  sx={{ '&.Mui-checked': { color: BRAND.accentText } }}
                />
              )}
              label={option.label}
            />
          ))}
        </FormGroup>
      )}
      {error ? (
        <Typography variant="caption" sx={{ color: '#f44336', mt: 0.5, display: 'block' }}>
          {t(error)}
        </Typography>
      ) : null}
    </Box>
  );
};

export default ServicePackageCheckboxGroup;
